import { Link } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import { TrackEventGTM } from '../../utils/filters/analyticsUtils';
import { t } from '../../i18n/i18n';
import './SideBarDropDown.css';
import { EventsGTM } from '../../constants/events';

const SideBarDropDown = ({
  options,
  icon,
  collapsed,
  buttonText,
  imgClassName,
  imgWidth = '25',
  imgPadding = 'pr-1',
  selected,
  onClick,
  responsive,
  isMobile = false,
  isPremium = false,
  disabledFeature = false,
}) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (collapsed) {
      setShow(false);
    }
  }, [collapsed]);

  return (
    <div
      onKeyDown={() => {}}
      className={`position-relative cursor-pointer ${collapsed ? 'mr-4' : 'mr-0 w-100'} ${
        selected && 'sidebar-active'
      }`}
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
      role="menuitem"
      tabIndex="0"
      onClick={() => {
        TrackEventGTM(EventsGTM.SIDE_BAR_BUTTON, {
          event_category: `Click en ${buttonText}`,
          event_label: 'Sidebar',
          event_action: 'click',
        });
        if (buttonText === 'MENU_ITEM_CREATE_EVALUATION') {
          TrackEventGTM(EventsGTM.CLICK_CREATE_EVALUATION, {
            event_category: `Click en ${buttonText}`,
            event_label: 'Sidebar',
            event_action: 'click',
          });
        }
      }}
    >
      <div
        className={`nav-links__item ml-1 sidebar-item-link ${
          collapsed ? 'p-0' : 'p-2'
        } position-relative d-flex align-items-center text-white`}
        id={`${isMobile ? `${buttonText}-mobile` : buttonText}`}
      >
        <div
          height="25"
          width={imgWidth}
          className={`${disabledFeature ? '' : 'mr-3'} mb-1 ${imgPadding} ${
            imgClassName || 'ml-3'
          } ${selected ? 'icon-selected' : 'icon-normal'} ${
            isPremium === true ? 'fuction-disabled' : ''
          }`}
        >
          {icon}
        </div>
        <div
          className={`list-button border-0 py-2 position-relative d-flex justify-content-between align-items-center bg-transparent text-nowrap w-100 ${
            collapsed ? 'fuction-text-disabled' : ''
          } ${isPremium === true ? 'fuction-disabled' : ''}`}
        >
          <span
            className={`link_name  ml-0 text-xs ${collapsed && 'collapsed overflow-hidden'} ${
              isPremium === true ? 'fuction-disabled' : ''
            }`}
          >
            {t(buttonText)}
          </span>
        </div>
        {collapsed && (
          <ul
            className={`link-list collapsed-list position-absolute overflow-hidden top-0 list-unstyled py-2 
            ${show && 'show-list px-3'}
            `}
          >
            <span
              className={`text-white text-nowrap text-xs ml-0 font-weight-bold d-block ${
                options && 'pb-1'
              }`}
            >
              {t(buttonText)}
            </span>
            {options &&
              options.map(
                (option, index) =>
                  !!option.label && (
                    <li
                      key={index}
                      id={`${isMobile ? `${option?.label}-mobile` : option?.label}`}
                      onKeyPress={() => {}}
                      role="button"
                      className="m-0 py-1 pl-1 list-item text-white font-weight-bold"
                    >
                      <Link className=" text-xs" to={option.path}>
                        {t(option.label)}
                      </Link>
                    </li>
                  )
              )}
          </ul>
        )}
      </div>
      {!collapsed && (
        <ul
          className={`link-list overflow-hidden list-unstyled pl-4 w-100 ${collapsed && 'd-none'} ${
            responsive && 'bg-transparent'
          }`}
        >
          {options &&
            options.map(
              (option, index) =>
                !!option.label && (
                  <li
                    key={index}
                    className={`m-0 py-1 pl-4 ml-1 list-item text-white font-weight-bold ${
                      collapsed && 'd-none'
                    }`}
                    id={`${isMobile ? `${option?.label}-mobile` : option?.label}`}
                  >
                    <Link className=" pl-2 ml-1 text-xs" to={option.path}>
                      {t(option.label)}
                    </Link>
                  </li>
                )
            )}
        </ul>
      )}
    </div>
  );
};

export default SideBarDropDown;
